import { render, staticRenderFns } from "./model.vue?vue&type=template&id=32a286af&"
import script from "./model.vue?vue&type=script&lang=ts&"
export * from "./model.vue?vue&type=script&lang=ts&"
import style0 from "./model.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports